import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ObservationSchema = withDefaults({
  type: 'observation',
  objectExtensions: ['observation'],
  fields: [
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'value',
    },
    {
      kind: 'attribute',
      name: 'observationType',
    },
    {
      kind: 'attribute',
      name: 'provider',
    },
    {
      kind: 'attribute',
      name: 'providedAt',
    },
    {
      kind: 'attribute',
      name: 'staleAfter',
    },
    {
      kind: 'attribute',
      name: 'weight',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      // Polymorphic: the Account or Loan this observation is about
      // (type resolved from the payload).
      kind: 'belongsTo',
      name: 'observable',
      type: 'observable',
      options: {
        async: false,
        polymorphic: true,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'person',
      type: 'person',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'observableDocuments',
      type: 'observable-document',
      options: {
        async: false,
        inverse: 'observations',
      },
    },
  ],
});

export default ObservationSchema;
